<template>
  <div class="title">
    <span>{{ titleText }}</span>
  </div>
</template>

<script>
export default {
  props: ["titleText"],
};
</script>

<style lang="scss">
@import "../assets/public.scss";

.title {
  @include bg("title_bg.png");
  margin: auto;

  @include wh(700, 99);
  span {
    line-height: normal;
    font-family: "SairaStencilOne";
    font-weight: bold;
    color: #bf986e;
    background: linear-gradient(0deg, #a4b0c5 0%, #f2f7ff 99.31640625%);
    -webkit-background-clip: text;
    color: transparent;
    display: inline;
    width: 100%;
    @include ft(40);
    @include lh(99);
    position: relative;

    &:after {
      position: absolute;
      top: 50%;
      right: 0%;
      transform: translate(150% , -50%);
      content: "";
      @include wh(24, 24);
      @include bg("title-R.png");
    }
     &::before {
      position: absolute;
      top: 50%;
      left: 0%;
      transform: translate(-150% , -50%);
      content: "";
      @include wh(24, 24);
      @include bg("title-L.png");
    }
  }
}
</style>